import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Input } from '../ui/input';

export const AccountDetailField = ({ icon: Icon, label, description, fullWidth, inputId, testId, labelTestId, statusId, status, verified, verifiedTestId, value, placeholder, disabled, children }) => (
  <div className={`settings-detail-field${fullWidth ? ' is-full-width' : ''}`} data-testid={testId}>
    <div className={`settings-detail-field-heading${status ? ' has-status' : ''}`}>
      <span className="settings-field-icon" aria-hidden="true" data-testid={`${testId}-icon`}><Icon size={20} /></span>
      <div className="settings-detail-labels"><label htmlFor={inputId} data-testid={labelTestId}>{label}</label>{description && <p className="settings-field-description" id={`${inputId}-description`} data-testid={`${inputId}-description`}>{description}</p>}</div>
      {status && <span className={`settings-detail-status${verified ? ' is-verified' : ''}`} id={statusId} data-testid={statusId}>
        {verified && <span data-testid={verifiedTestId} title="Verified connection" aria-label="Verified connection"><CheckCircle2 size={15} aria-hidden="true" /></span>}
        {status}
      </span>}
    </div>
    <Input id={inputId} data-testid={inputId} value={value} title={value || undefined} placeholder={placeholder} readOnly disabled={disabled} aria-describedby={[description && `${inputId}-description`, status && statusId].filter(Boolean).join(' ') || undefined} />
    {children}
  </div>
);